import { addNavMenuSection } from "@vendure/admin-ui/core";

export default [
        addNavMenuSection(
            {
                id: 'marketing',
                label: 'Marketing',
                items: [
                    {
                        id: 'hyperclicks-contacts',
                        label: 'Hyperclicks Contact-us',
                        routerLink: ['/extensions/hyperclicks-contacts'],
                        icon: 'list',
                    },
                ],
            },
        ),
];
